import {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState,
} from "react";

interface TabSwitcherContextProps {
  activeTabID: string;
  setActiveTabID: Dispatch<SetStateAction<string>>;
}

const TabSwitcherContext = createContext({} as TabSwitcherContextProps);

interface TabSwitcherProviderProps {
  initialActiveTabId: string;
}

export const TabSwitcherProvider: FC<TabSwitcherProviderProps> = ({
  children,
  initialActiveTabId,
}) => {
  const [activeTabID, setActiveTabID] = useState(initialActiveTabId);

  return (
    <TabSwitcherContext.Provider
      value={{
        activeTabID,
        setActiveTabID,
      }}
    >
      {children}
    </TabSwitcherContext.Provider>
  );
};

export const useTabSwitcher = () => {
  const context = useContext(TabSwitcherContext);

  if (!context || Object.keys(context).length === 0) {
    throw new Error(
      "useTabSwitcher must bet used within a TabSwitcherProvider"
    );
  }

  return context;
};
